<template lang="pug">
    //- Under a shared field of a variant article: does the shop show the product's value or
    //- this article's own? (api docs/features/PRODUCT_ARTICLE_INHERITANCE.md section 10)
    .inherited-value-hint(:class="{ own }")
        template(v-if="own")
            span {{ $t('Own value') }}
            el-button(type="text" size="mini" @click="$emit('reset')") {{ $t('Use product value') }}
        span(v-else) {{ $t('Inherited from product') }}
</template>

<i18n>
{
    "de": {
        "Own value": "Eigener Wert",
        "Use product value": "Produktwert verwenden",
        "Inherited from product": "Vom Produkt übernommen"
    }
}
</i18n>

<script>
export default {
    name: 'InheritedValueHint',
    props: {
        // the article holds its own value for this field
        own: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="sass" scoped>
.inherited-value-hint
    display: flex
    align-items: center
    gap: .5rem
    margin-top: .25rem
    font-size: 12px
    line-height: 1.4
    color: $--color-text-secondary

    &.own
        color: $--color-text-primary

    .el-button
        padding: 0
</style>
